/**
 * On phones, data tables (Admin, Founder Console, ...) read better as stacked
 * cards. This copies each column's header text onto its cells as data-label;
 * CSS in a11y.css (table.fz-card-table, max-width 640px) lays rows out as
 * cards with "Label  value" lines. Desktop layout is unchanged.
 */
function labelTable(table) {
  const headers = Array.from(table.querySelectorAll('thead th')).map((th) => th.textContent.trim());
  if (!headers.length) return;
  table.classList.add('fz-card-table');
  // A sideways-scrolling wrapper must be focusable so keyboard users can scroll it.
  const scroller = table.parentElement;
  if (scroller && !scroller.hasAttribute('tabindex')) {
    const ox = getComputedStyle(scroller).overflowX;
    if (ox === 'auto' || ox === 'scroll') {
      scroller.setAttribute('tabindex', '0');
      scroller.setAttribute('role', 'region');
      scroller.setAttribute('aria-label', `${headers.slice(0, 3).join(', ')} table`);
    }
  }
  table.querySelectorAll('tbody tr').forEach((tr) => {
    Array.from(tr.children).forEach((cell, i) => {
      const label = headers[i] || '';
      if (cell.getAttribute('data-label') !== label) cell.setAttribute('data-label', label);
    });
  });
}

export function enableCardTables() {
  if (typeof window === 'undefined' || !window.MutationObserver) return;
  let queued = false;
  const run = () => {
    queued = false;
    document.querySelectorAll('table').forEach(labelTable);
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(run);
  };
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
}
